import React, { createContext, useContext, useState } from 'react';
import { MessageProvider } from '@messageformat/react';
import { Locale, LocaleProvider } from '@op/opds.opux';

import messages from '../messages/messages';

interface LanguageState {
    language: Locale;
    setLanguage: Function;
}

export const CardLanguageContext = createContext<LanguageState | null>(null);

export const CardLanguageContextProvider: React.FC<{
    children: React.ReactNode;
    locale: Locale;
}> = ({ children, locale }) => {
    const setLanguage = (language: Locale) => {
        setState((previousState) => {
            return { ...previousState, language };
        });
    };

    const [state, setState] = useState<LanguageState>({
        language: locale,
        setLanguage,
    });

    return (
        <CardLanguageContext.Provider value={state}>
            <LocaleProvider locale={state.language}>
                <MessageProvider
                    locale={state.language}
                    messages={messages[state.language] || messages.en}>
                    {children}
                </MessageProvider>
            </LocaleProvider>
        </CardLanguageContext.Provider>
    );
};

export const useCardLanguage = () => useContext(CardLanguageContext);
